import React from "react";
import {
  Box,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from "@mui/material";

const RadioForm = ({
  orderFormFieldKey,
  orderFormFieldTouched,
  orderFormFieldError,
  nameText,
  value,
  options,
  handleChange,
  handleBlur,
}) => {
  if (!options || !Array.isArray(options)) {
    return null;
  }

  return (
    <Box
      key={orderFormFieldKey}
      sx={{
        marginTop: "20px",
        width: "100%",
      }}
    >
      <FormControl
        sx={{}}
        error={Boolean(orderFormFieldTouched && orderFormFieldError)}
      >
        <FormLabel id={`${orderFormFieldKey}-label`}>{nameText}</FormLabel>
        <RadioGroup
          aria-labelledby={`${orderFormFieldKey}-label`}
          value={value}
          name={orderFormFieldKey}
          onChange={handleChange}
        >
          {options.map(({ key, name }, index) => {
            return (
              <FormControlLabel
                key={key || `option-${index}`}
                value={key || `option-${index}`}
                control={<Radio />}
                label={name || ""}
              />
            );
          })}
        </RadioGroup>
        <FormHelperText>
          {" "}
          {orderFormFieldTouched && orderFormFieldError
            ? orderFormFieldError
            : " "}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};

export default RadioForm;
